<template>
  <v-dialog :value="value" persistent max-width="1500px" attach="#modal-portal">
    <v-card class="mx-auto">
      <v-toolbar dark color="primary" height="45">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn small icon color="primary" @click="closeForm"><v-icon>close</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form @submit.prevent="saveSendingMessageName" ref="form">
          <v-card>
            <v-container fluid grid-list-sm class="py-2">
              <v-layout>
                <div>
                  <v-btn color="primary" fab small title="Preview" @click="openPreview">
                    <i class="fa fa-binoculars"></i>
                  </v-btn>
                  <v-btn
                    color="primary"
                    fab
                    small
                    title="Transaction list"
                    v-show="showStatistics"
                    @click="openTransactionList"
                  >
                    <i class="fa fa-list-alt"></i>
                  </v-btn>
                  <v-btn
                    color="primary"
                    fab
                    small
                    title="Export to Excel Transaction list"
                    v-show="showStatistics"
                    @click="exportToExcelTransactionList"
                  >
                    <i class="k-icon k-i-excel"></i>
                  </v-btn>
                  <v-btn
                    v-show="isEditable && showMessage"
                    color="primary"
                    fab
                    small
                    title="Update or Save new"
                    type="submit"
                    :disabled="saving"
                  >
                    <v-progress-circular indeterminate v-if="saving" />
                    <i class="fa fa-check"></i>
                  </v-btn>
                </div>
                <v-layout v-show="showMessage">
                  <vonap-form-label label="Source">
                    <kendo-dropdownlist
                      :value="clientId"
                      :data-source="clientDataSource"
                      data-text-field="name"
                      data-value-field="id"
                      :disabled="!isEditable"
                      :change="onClientChange"
                      xs2
                    >
                    </kendo-dropdownlist>
                  </vonap-form-label>
                  <vonap-form-label label="Message">
                    <kendo-dropdownlist
                      :value="sendingMessageId"
                      :data-source="sendingMessageDataSource"
                      data-text-field="name"
                      data-value-field="id"
                      :disabled="!isEditable"
                      :change="onSendingMessageChange"
                      xs5
                    >
                    </kendo-dropdownlist>
                  </vonap-form-label>
                  <v-text-field
                    xs6
                    label="Subject:"
                    v-model="subject"
                    type="text"
                    :disabled="!isEditable || isMessageReadOnly"
                  ></v-text-field>
                </v-layout>
              </v-layout>
              <v-layout v-show="showMessage">
                <v-textarea
                  xs2
                  v-model="message"
                  type="text"
                  label="Message"
                  :disabled="!isEditable || isMessageReadOnly"
                ></v-textarea>
              </v-layout>
              <v-layout v-show="showStatistics && isEditable">
                <v-toolbar dark color="primary" height="45">
                  <v-toolbar-items>
                    <kendo-button
                      type="button"
                      title="Calculate Statistics"
                      class="k-button-icon"
                      @click="calculateStatistics"
                    >
                      <i class="fa fa-bolt"></i>
                    </kendo-button>
                  </v-toolbar-items>
                </v-toolbar>
              </v-layout>
              <v-layout v-show="showStatistics">
                <kendo-grid
                  ref="statisticLineGrid"
                  :editable="isEditable && {mode: 'inline', createAt: 'bottom'}"
                  :dataSource="statisticLineGridDataSource"
                  :columns="statisticColumns"
                  :pageable="true"
                  style="width:1450px"
                ></kendo-grid>
              </v-layout>

              <v-layout v-show="showTextLine && isEditable">
                <v-toolbar dark color="primary" height="45">
                  <v-toolbar-items>
                    <div v-show="!addExistingPanel">
                      <kendo-button
                        type="button"
                        title="Calculate Economy"
                        @click="calculateEconomy"
                        v-if="showStatistics"
                      >
                        <i class="fa fa-bolt"></i>
                      </kendo-button>
                      <kendo-button type="button" title="Add Existing" @click="addExisting">
                        <i class="fa fa-search-plus"></i>
                      </kendo-button>
                      <kendo-button type="button" title="Add New" @click="addNew">
                        <i class="fa fa-plus"></i>
                      </kendo-button>
                    </div>
                    <div v-show="addExistingPanel">
                      <kendo-button type="button" title="Save" @click="saveAddExisting">
                        <i class="fa fa-check"></i>
                      </kendo-button>
                      <kendo-button type="button" title="Save" @click="addExistingPanel = false">
                        <i class="fa fa-ban"></i>
                      </kendo-button>
                      <kendo-dropdownlist
                        :value="addExistingDetOtherTextId"
                        :data-source="addMissingDetOtherTextDataSource"
                        :data-text-field="'description'"
                        :data-value-field="'detOtherTextId'"
                        @change="onAddExistingDetOtherTextChange"
                        @databound="onAddExistingDetOtherTextDataBound"
                        filter="contains"
                        style="width:400px"
                      ></kendo-dropdownlist>
                    </div>
                  </v-toolbar-items>
                </v-toolbar>
              </v-layout>
              <v-layout v-show="showTextLine">
                <kendo-grid
                  ref="grid"
                  :editable="isEditable && {mode: 'inline', createAt: 'bottom'}"
                  :dataSource="gridDataSource"
                  :columns="columns"
                  style="width:1450px"
                ></kendo-grid>
              </v-layout>
              <v-divider></v-divider>
            </v-container>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>

    <dashboard-bon-coup-preview
      v-model="showMessagePreview"
      :monthly-report-sending-id="monthlyReportSendingId"
      :monthly-report-sending-list-detail-id="getDetailId"
      @input="toggleSendingMessagePreview($event)"
    />

    <transaction-list-detail
      v-model="showTransactionListDetail"
      :as-of-date="asOfDate"
      :client-id="selectedClientId"
      @input="toggleTransactionListDetail($event)"
    />
  </v-dialog>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import notification from '@/helpers/notification'
import DashboardBonCoupPreview from '@/views/Report/DashboardBonCoupPreview'
import VonapFormLabel from '@/components/VonapFormLabel'
import TransactionListDetail from '@/components/TransactionListDetail'
import {
  checkboxColumn,
  jsonDropDownEditor,
  numericEditor,
  readOnlyEditor,
} from '@/helpers/kendo-editors'
import security from '@/mixins/security'
import params from '@/helpers/params'
const $ = kendo.jQuery

export default {
  mixins: [security],
  name: 'SendingMessageWindow',
  props: {
    value: {type: Boolean},
    monthlyReportSendingId: {type: Number},
    monthlyReportSendingListDetailId: {type: Number},
    languageId: {type: Number},
    formParams: {type: Object},
    asOfDate: {type: String, defaultValue: null},
    selectedClientId: {type: Number, defaultValue: -1},
    editable: {type: Boolean, defaultValue: false},
  },
  mounted() {
    this.getData()
    this.dragAndDropGrid(!this.isEditable)
  },
  components: {
    VonapFormLabel,
    DashboardBonCoupPreview,
    TransactionListDetail,
  },
  computed: {
    ...mapGetters({currentUsername: 'authentication/currentUsername'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),

    isEditable() {
      return !this.isReadOnly && this.editable
    },
    processedMessage() {
      return this.format(this.message, this.parameters)
    },
    getDetailId() {
      return this.showMessagePreview ? this.monthlyReportSendingListDetailId : 0
    },
    clientDataSource() {
      return new kendo.data.DataSource({
        data: [{id: 0, name: 'Master'}, {id: +this.parentClientId, name: 'Client'}],
      })
    },
    columns() {
      return [
        {
          template: '<span class="k-icon k-i-reorder drag-handle" title="Drag to reorder" />',
          attributes: {class: 'drag-handle', style: 'text-align:center;padding:2px 0'},
          width: 40,
          hidden: !this.isEditable,
        },
        {
          hidden: !this.isEditable,
          command: 'edit',
          title: '&nbsp;',
          width: 58,
        },
        checkboxColumn(
          'isShown',
          {
            title: 'Shown',
            width: 82,
          },
          !this.isEditable,
        ),
        {
          title: 'Description',
          field: 'description',
          width: 582,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor(container, options) {
            const {model} = options
            if (model.clientId === 0) {
              return readOnlyEditor.call(this, container, options)
            }
            const input = kendo.jQuery(
              `<input class="k-input k-textbox" name="${options.field}" required="required" />`,
            )
            input.appendTo(container)
          },
        },
        {
          title: 'Amount',
          field: 'amount',
          attributes: {style: 'text-align:right'},
          width: 100,
          format: '{0:N0}',
          editor: numericEditor(
            {
              decimals: 16,
              format: '{0:n0}',
              spinners: false,
            },
            false,
          ),
        },
        {
          title: 'Ccy',
          field: 'ccy',
          width: 82,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor: jsonDropDownEditor(
            'ccy',
            'ccy',
            '/api/report/SendingMessage/getCcies?clientId=0',
            {},
            false,
          ),
        },
        {
          title: 'Param',
          field: 'paramId',
          width: 82,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          template: '#=paramName ? paramName : ""#',
          editor: jsonDropDownEditor(
            'paramId',
            'name',
            '/api/report/SendingMessage/getParams',
            {},
            false,
          ),
        },
        {
          command: [{name: 'destroy', visible: () => true}],
          width: 82,
          attributes: {style: 'text-align: center;'},
          hidden: !this.isEditable,
        },
        {},
      ].filter(c => c.editable !== false)
    },
    statisticColumns() {
      return [
        {
          hidden: !this.isEditable,
          command: 'edit',
          title: '&nbsp;',
          width: 58,
        },
        {
          field: 'transactional',
          title: 'Transactional',
          attributes: {style: 'text-align:right'},
          width: 200,
        },
        {
          field: 'amount',
          title: 'Amount',
          attributes: {style: 'text-align:right'},
          width: 100,
          format: '{0:N0}',
          editor: numericEditor(
            {
              decimals: 16,
              format: '{0:n0}',
              spinners: false,
            },
            true,
          ),
        },
        {
          field: 'ccyPair',
          title: 'Ccy Pair',
          width: 90,
        },
        {
          field: 'rateType1',
          title: 'Rate Nature',
          width: 114,
        },
        {
          field: 'rate1',
          title: 'First Rate',
          attributes: {style: 'text-align:right'},
          width: 72,
          format: '{0:N4}',
          editor: numericEditor(
            {
              decimals: 16,
              format: '{0:n4}',
              spinners: false,
            },
            true,
          ),
        },
        {
          field: 'rateType2',
          title: '2nd Rate Nature',
          width: 114,
        },
        {
          field: 'rate2',
          title: 'Second Rate',
          attributes: {style: 'text-align:right'},
          width: 72,
          format: '{0:N4}',
          editor: numericEditor(
            {
              decimals: 16,
              format: '{0:n4}',
              spinners: false,
            },
            false,
          ),
        },
        {
          field: 'rateType3',
          title: '3rd Rate Nature',
          width: 114,
        },
        {
          field: 'rate3',
          title: 'Third Rate',
          attributes: {style: 'text-align:right'},
          width: 72,
          format: '{0:N4}',
          editor: numericEditor(
            {
              decimals: 16,
              format: '{0:n4}',
              spinners: false,
            },
            false,
          ),
        },
        {
          field: 'economy',
          title: 'Economy',
          attributes: {style: 'text-align:right'},
          width: 108,
          format: '{0:N2}',
          editor: numericEditor(
            {
              decimals: 16,
              format: '{0:n2}',
              spinners: false,
            },
            true,
          ),
        },
        {
          title: 'Ccy',
          field: 'ccy',
          width: 61,
        },
        {
          field: 'budRate',
          title: 'Bud. Rate',
          attributes: {style: 'text-align:right'},
          width: 72,
          format: '{0:N4}',
          editor: numericEditor(
            {
              decimals: 16,
              format: '{0:n4}',
              spinners: false,
            },
            true,
          ),
        },
        {
          field: 'budImpact',
          title: 'Bud. Impact',
          attributes: {style: 'text-align:right'},
          width: 100,
          format: '{0:N0}',
          editor: numericEditor(
            {
              decimals: 16,
              format: '{0:n0}',
              spinners: false,
            },
            true,
          ),
        },
        checkboxColumn(
          'isManual',
          {title: 'Manual', width: 80, hidden: false},
          !this.isEditable,
          null,
          function(row) {
            return !row.isManual
          },
        ),
        {},
      ].filter(c => c.editable !== false)
    },
    isMessageReadOnly() {
      return this.clientId == 0
    },
  },
  data() {
    return {
      sendingMessageId: 0,
      saving: false,
      title: '',
      subject: '',
      messageName: '',
      message: '',
      clientId: 0,
      parentClientId: 0,
      sendingMessageReportId: 0,
      clientName: '',
      sendingMessageDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/report/SendingMessage/getMessagesByClient',
            data: () => {
              return {
                sendingMessageReportId: +this.sendingMessageReportId,
                languageId: +this.languageId,
                clientId: +this.clientId,
              }
            },
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
      showTransactionsPanel: true,
      ccyPairValue: 1,
      ccyPairDataSource: [{text: 'All', value: 0}, {text: 'Selected', value: 1}],
      resetMessageId: 0,
      parameters: {},
      showMessagePreview: false,
      showTransactionListDetail: false,
      gridDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 10,
        transport: {
          read: {
            type: 'GET',
            url: '/api/report/SendingMessage/grid',
            data: () => ({monthlyReportSendingListDetailId: this.monthlyReportSendingListDetailId}),
            dataType: 'json',
          },
          create: {
            type: 'POST',
            url: '/api/report/SendingMessage/grid',
            data: () => ({monthlyReportSendingListDetailId: this.monthlyReportSendingListDetailId}),
            complete: () => {
              this.gridDataSource.read()
            },
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/report/SendingMessage/grid',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/report/SendingMessage/grid',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'detOtherTextId',
            fields: {
              detOtherTextId: {type: 'number', editable: false},
              isShown: {type: 'boolean', defaultValue: true},
              description: {type: 'string', validation: {required: true}},
              amount: {type: 'number', defaultValue: null, validation: {required: false}},
              ccy: {type: 'string', editable: true},
              paramId: {type: 'number', defaultValue: 0},
              paramName: {type: 'string', defaultValue: 'No Value'},
            },
          },
        },
      }),
      saveReset: false,
      addExistingPanel: false,
      addExistingDetOtherTextId: 0,
      addMissingDetOtherTextDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/report/SendingMessage/getMissingDetOtherTexts',
            data: () => {
              return {
                monthlyReportSendingListDetailId: +this.monthlyReportSendingListDetailId,
              }
            },
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
      showStatistics: false,
      showTextLine: false,
      showMessage: false,
      statisticLineGridDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 10,
        transport: {
          read: {
            type: 'GET',
            url: '/api/report/SendingMessage/statisticLineGrid',
            data: () => ({
              monthlyReportSendingListDetailId: this.monthlyReportSendingListDetailId,
              languageId: this.languageId,
            }),
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/report/SendingMessage/statisticLineGrid',
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'statisticLineId',
            fields: {
              statisticLineId: {type: 'number', editable: false},
              productEnumId: {type: 'number', editable: false},
              productEnum: {type: 'string', editable: false},
              ccyPairId: {type: 'number', editable: false},
              ccyPair: {type: 'string', editable: false},
              tradeTypeEnumId: {type: 'number', editable: false},
              tradeTypeEnum: {type: 'string', editable: false},
              transactional: {type: 'string', editable: false},
              amount: {type: 'number', editable: true},
              rateType1Id: {type: 'number', editable: false},
              rateType1: {type: 'string', editable: false},
              rate1: {type: 'number', editable: true, validation: {required: false}},
              rateType2Id: {type: 'number', editable: false},
              rateType2: {type: 'string', editable: false},
              rate2: {type: 'number', editable: true, validation: {required: false}},
              rateType3Id: {type: 'number', editable: false},
              rateType3: {type: 'string', editable: false},
              rate3: {type: 'number', editable: true, validation: {required: false}},
              economy: {type: 'number', editable: true},
              ccy: {type: 'string', editable: false},
              budRate: {type: 'number', editable: true, validation: {required: false}},
              budImpact: {type: 'number', editable: true, validation: {required: false}},
              isManual: {type: 'boolean', editable: true, validation: {required: false}},
            },
          },
        },
      }),
    }
  },
  methods: {
    format(str, values) {
      const lowerValues = Object.entries(values).reduce(
        (acc, [key, value]) => ({...acc, [key.toLowerCase()]: value}),
        {},
      )
      return str.replace(/@(\w+)/g, (_, match) => {
        const value = lowerValues[match.toLowerCase()]
        return typeof value !== 'undefined' ? value : _
      })
    },
    dragAndDropGrid(hide) {
      const grid = this.$refs.grid.kendoWidget()

      if (hide) {
        let dragAndDrop = grid.table.data('kendoSortable')
        if (dragAndDrop) dragAndDrop.destroy()
        grid.hideColumn(0)
      } else {
        if (!this.isEditable) return
        grid.showColumn(0)
        grid.table.kendoSortable({
          handler: '.drag-handle',
          filter: 'tr:not(tr[data-role=editable])',
          hint: function(element) {
            var table = $('<table style="width: 600px;" class="k-grid k-widget"></table>')
            table.append(element.clone())
            table.css('opacity', 0.7)

            return table
          },
          cursor: 'move',
          placeholder: function() {
            return $('<tr colspan="4" class="placeholder"></tr>')
          },
          change: async e => {
            const skip = grid.dataSource.skip(),
              newIndex = e.newIndex + skip,
              selectedDataItem = grid.dataSource.getByUid(e.item.data('uid'))

            grid.dataSource.remove(selectedDataItem)
            grid.dataSource.insert(newIndex, selectedDataItem)

            await axios.post('/api/report/SendingMessage/updateSequence', {
              monthlyReportSendingListDetailId: this.monthlyReportSendingListDetailId,
              otherTextId: selectedDataItem.otherTextId,
              newIndex: e.newIndex,
            })
            await grid.dataSource.read()
          },
        })
      }
    },
    async save() {
      if (!this.$refs.form.validate()) return

      this.saving = true
      const formData = {
        sendingMessageId: this.sendingMessageId,
        subject: this.subject,
        name: this.messageName,
        message: this.message,
        clientId: this.clientId,
        clientName: this.clientName,
        resetMessageId: this.resetMessageId,
        monthlyReportSendingListDetailId: this.monthlyReportSendingListDetailId,
        saveReset: this.saveReset,
        reportDate: this.asOfDate,
      }
      const response = await axios.post('/api/report/SendingMessage', formData).catch(() => {
        notification('Some error', 'error')
        this.saving = false
      })

      if (response.status == 200) {
        notification('Message saved successfully')
        this.$emit('success')
      }

      this.saving = false
    },
    async getData() {
      const req = await axios
        .get('/api/report/SendingMessage', {
          params: {
            sendingMessageListDetailId: +this.monthlyReportSendingListDetailId,
            asOfDate: this.asOfDate,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error ', 'error'))
      const {data} = req
      this.title = data.title
      this.subject = data.subject
      this.messageName = data.name
      this.message = data.message
      setTimeout(async () => {
        this.clientId = data.clientId
        await this.sendingMessageDataSource.read()
        this.sendingMessageId = data.sendingMessageId
        this.resetMessageId = data.resetMessageId
      }, 100)
      this.parentClientId = data.parentClientId
      this.sendingMessageReportId = data.sendingMessageReportId
      this.clientName = data.clientName
      this.parameters = data.parameters
      this.showStatistics = data.hasStatistics
      this.showTextLine = data.hasTextLine
      this.showMessage = data.hasMessage
    },
    closeForm() {
      this.$emit('input', false)
    },
    openPreview() {
      this.toggleSendingMessagePreview(true)
    },
    toggleSendingMessagePreview(e) {
      this.showMessagePreview = e
    },
    openTransactionList() {
      this.toggleTransactionListDetail(true)
    },
    toggleTransactionListDetail(e) {
      this.showTransactionListDetail = e
    },
    exportToExcelTransactionList() {
      const exportUrl = '/api/report/SendingMessage/exportTransactionListDetail'
      const qs = params.fromObject({
        asOfDate: this.asOfDate,
        clientId: this.selectedClientId,
        t: this.tokenString,
      })
      location.href = `${exportUrl}?${qs}`
    },
    async resetMessageButton() {
      const url = '/api/report/SendingMessage/resetMessage'
      const params = {
        resetMessageId: this.resetMessageId,
        sendingMessageId: this.sendingMessageId,
        asOfDate: this.asOfDate,
      }
      await axios.put(url, params)
      this.getData()
    },
    onAddExistingDetOtherTextChange({sender}) {
      this.addExistingDetOtherTextId = +sender.value()
    },
    onAddExistingDetOtherTextDataBound({sender}) {
      sender.select(0)
      this.addExistingDetOtherTextId = +sender.value()
    },
    saveSendingMessageName(e) {
      this.messageName = e.value
      this.save()
    },
    async onClientChange({sender}) {
      this.clientId = +sender.value()
      this.subject = ''
      this.message = ''
      await this.sendingMessageDataSource.read()
      const firstSendingMessage = this.sendingMessageDataSource.data()[0]
      const firstSendingMessageId = firstSendingMessage ? firstSendingMessage.id : null
      if (firstSendingMessageId) {
        this.sendingMessageId = firstSendingMessageId
        await this.refreshMessage(firstSendingMessageId)
      }
    },
    async onSendingMessageChange({sender}) {
      const sendingMessageId = +sender.value()
      return this.refreshMessage(sendingMessageId)
    },
    async refreshMessage(sendingMessageId) {
      const data = await this.getSendingMessage(sendingMessageId)
      this.sendingMessageId = data.sendingMessageId
      this.title = data.title
      this.subject = data.subject
      this.messageName = data.name
      this.message = data.message
      //setTimeout(() => (this.clientId = data.clientId), 100)
      this.clientName = data.clientName
      //this.parentClientId = data.parentClientId
      this.resetMessageId = data.resetMessageId
    },
    async getSendingMessage(sendingMessageId) {
      const req = await axios
        .get('/api/report/SendingMessage/getSendingMessage', {
          params: {
            sendingMessageId,
            asOfDate: this.asOfDate,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error ', 'error'))
      const {data} = req
      return data
    },
    addNew() {
      const grid = this.$refs.grid.kendoWidget()
      grid.addRow()
    },
    async addExisting() {
      await this.addMissingDetOtherTextDataSource.read()
      this.addExistingPanel = true
    },
    async saveAddExisting() {
      this.addExistingPanel = false
      await axios.post('/api/report/SendingMessage/addExisting', {
        monthlyReportSendingListDetailId: this.monthlyReportSendingListDetailId,
        detOtherTextId: this.addExistingDetOtherTextId,
        clientId: this.selectedClientId,
      })
      this.$refs.grid.kendoWidget().dataSource.read()
    },
    async calculateStatistics() {
      if (!confirm('Are your sure you want to calculate statistics?')) return
      await axios.post('/api/report/monthlyReportSendingList/executeProcess', {
        asOfDate: this.asOfDate,
        clientId: this.selectedClientId,
      })
      await this.statisticLineGridDataSource.read()
      await this.gridDataSource.read()
    },
    async calculateEconomy() {
      if (!confirm('Are your sure you want to calculate the Economy Total?')) return
      await axios.post('/api/report/monthlyReportSendingList/executeEconomyProcess', {
        asOfDate: this.asOfDate,
        monthlyReportSendingListDetailId: this.monthlyReportSendingListDetailId,
      })
      await this.gridDataSource.read()
    },
  },
  watch: {
    monthlyReportSendingListDetailId(newVal) {
      if (newVal) {
        this.getData()
      }
    },
    resetMessageId(newVal) {
      if (newVal) {
        this.resetMessagesDataSource.read()
      }
    },
  },
}
</script>
